/**
 * 前端权限判定。key 来自 shared/permissionKeys.js（前后端唯一真源）。
 * 登录后以 `userInfo.access[]` 为准；没有快照则视为无权限。
 */

import { PERM } from 'pringxsoft-shared/permissionKeys.js';

export { PERM };

export const MENU_DASHBOARD_STAT_CARDS = PERM.MENU_DASHBOARD_STAT_CARDS;
export const MENU_PROFILE = PERM.MENU_PROFILE;
export const MENU_NOTIFICATION_LIST = PERM.MENU_NOTIFICATION_LIST;
export const MENU_STATISTICS_VIEW = PERM.MENU_STATISTICS_VIEW;
export const MENU_APPROVAL_APPLICATIONS = PERM.MENU_APPROVAL_APPLICATIONS;
export const MENU_APPROVAL_RECORDS = PERM.MENU_APPROVAL_RECORDS;
export const MENU_ORDER_CREATE = PERM.MENU_ORDER_CREATE;
export const MENU_ORDER_QUOTATION = PERM.MENU_ORDER_QUOTATION;
export const MENU_USER_LIST = PERM.MENU_USER_LIST;
export const MENU_LOGINLOG_LIST = PERM.MENU_LOGINLOG_LIST;
export const MENU_CUSTOMER_LIST = PERM.MENU_CUSTOMER_LIST;
export const MENU_PRODUCT_LIST = PERM.MENU_PRODUCT_LIST;
export const MENU_BRAND_LIST = PERM.MENU_BRAND_LIST;
export const MENU_SUPPLIER_LIST = PERM.MENU_SUPPLIER_LIST;
export const MENU_PERFORMANCE_LIST = PERM.MENU_PERFORMANCE_LIST;
export const MENU_ORDER_LIST = PERM.MENU_ORDER_LIST;
export const MENU_ORDER_DRAFT = PERM.MENU_ORDER_DRAFT;
export const ORDER_QUERY_TENANT_ALL = PERM.ORDER_QUERY_TENANT_ALL;
export const ORDER_DRAFT_QUERY_TENANT_ALL = PERM.ORDER_DRAFT_QUERY_TENANT_ALL;
export const ORDER_QUERY_ALL = PERM.ORDER_QUERY_ALL;
export const ORDER_DRAFT_QUERY_ALL = PERM.ORDER_DRAFT_QUERY_ALL;
export const APPROVAL_CUSTOMER_EXECUTE = PERM.APPROVAL_CUSTOMER_EXECUTE;
export const APPROVAL_QUOTA_EXECUTE = PERM.APPROVAL_QUOTA_EXECUTE;
export const APPROVAL_ORDER_EXECUTE = PERM.APPROVAL_ORDER_EXECUTE;
export const APPROVAL_FINAL_COST_EXECUTE = PERM.APPROVAL_FINAL_COST_EXECUTE;
export const USER_QUERY = PERM.USER_QUERY;
export const USER_UPDATE = PERM.USER_UPDATE;
export const PERFORMANCE_BULK_REMATCH = PERM.PERFORMANCE_BULK_REMATCH;
export const PERFORMANCE_QUERY = PERM.PERFORMANCE_QUERY;
export const PERFORMANCE_UPDATE = PERM.PERFORMANCE_UPDATE;
export const DASHBOARD_ORDER_FINAL_COST_VERIFICATION = PERM.DASHBOARD_ORDER_FINAL_COST_VERIFICATION;
export const ORDER_FINAL_COST_CONFIRM = PERM.ORDER_FINAL_COST_CONFIRM;
export const ORDER_FINAL_COST_ADJUST = PERM.ORDER_FINAL_COST_ADJUST;
export const ORDER_FINAL_COST_APPLY = PERM.ORDER_FINAL_COST_APPLY;

/** 绩效规则库菜单与 /performancerules */
export function canAccessPerformanceRulesManagement(userInfo) {
	return hasPermission(userInfo, PERM.PERFORMANCE_QUERY) && hasPermission(userInfo, PERM.PERFORMANCE_UPDATE);
}

/** 仪表盘「待核验」Tab 与列表 */
export function canAccessFinalCostVerificationDashboard(userInfo) {
	return hasPermission(userInfo, PERM.DASHBOARD_ORDER_FINAL_COST_VERIFICATION);
}

/** 订单详情内绩效结算 / 最终成本区块 */
export function canViewOrderPerformanceSettlement(userInfo) {
	return (
		hasAnyPermission(userInfo, [PERM.ORDER_FINAL_COST_CONFIRM, PERM.ORDER_FINAL_COST_ADJUST, PERM.ORDER_FINAL_COST_APPLY]) ||
		canAccessFinalCostVerificationDashboard(userInfo)
	);
}

export function canConfirmOrderFinalCost(userInfo) {
	return hasPermission(userInfo, PERM.ORDER_FINAL_COST_CONFIRM);
}

export function canAdjustOrderFinalCost(userInfo) {
	return hasPermission(userInfo, PERM.ORDER_FINAL_COST_ADJUST);
}

export const parsePermissionText = (text) =>
	String(text || '')
		.split(/[\n,]+/)
		.map((item) => item.trim())
		.filter(Boolean);

export function hasPermission(userInfo, permissionKey) {
	if (!userInfo || !permissionKey || !Array.isArray(userInfo.access)) return false;
	return userInfo.access.includes(permissionKey);
}

export function hasAnyPermission(userInfo, permissionKeys) {
	const keys = Array.isArray(permissionKeys) ? permissionKeys : [permissionKeys];
	return keys.some((key) => hasPermission(userInfo, key));
}

/** 统计页 / 首页固定图表：制作、保存、管理 */
export function canManageStatisticsDashboard(userInfo) {
	return hasAnyPermission(userInfo, [PERM.STATISTICS_DASHBOARD_CHARTS_EDIT, PERM.MENU_DASHBOARD_HOME_CHARTS]);
}

/** 仪表盘订单切片：只认权限点 */
export function canQueryDashboardOrderSlice(userInfo, permissionKey) {
	return hasPermission(userInfo, permissionKey);
}
